export default __webpack_public_path__ + "static/media/prototype-illustration.21bc4b3f.svg";